// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_zm_","cls2":"CiterightPreprintReport-cls2_BiT CiterightPreprintReport-cls1_zm_"};